import { useAbTest } from '@marketplace-web/feature-flags/ab-tests-data'
import { useFeatureSwitch } from '@marketplace-web/feature-flags/feature-switches-data'
import { useSession } from '@marketplace-web/shared/session-data'

const useIsSearchByImageEnabled = () => {
  const ab = useAbTest('search_by_image_v3')
  const fs = useFeatureSwitch('search_by_image_mvp_internal')
  const { user } = useSession()

  return (ab && ab.variant !== 'off') || fs || user?.email?.endsWith('@vinted.com')
}

export default useIsSearchByImageEnabled
